import {default as Component} from './ModalPopup'
import {connect} from 'react-redux'
import {closeModalPopup} from '../../redux/actions'

const ModalPopup = connect(
	(state, props) => {
		return {visible: !!state.modalPopup.visible[props.id]}
	},
	(dispatch, props) => {
		return {close: () => dispatch(closeModalPopup(props.id))}
	}
)(Component);

ModalPopup.defaultProps = {
	close: null
}

export default ModalPopup


// WEBPACK FOOTER //
// ./src/components/ModalPopup/index.js